import React from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import StoreCta from './StoreCta';

export default function AppShell({ children }) {
  const { user, logout, loading } = useAuth();
  const navigate = useNavigate();
  const { t, language, setLanguage, availableLanguages } = useLanguage();

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="nav-inner container">
          <Link to="/" className="brand">
            <span className="brand-mark">A</span>
            Aphel
          </Link>
          <nav className="nav-links">
            <NavLink to="/" end>
              {t('nav.landing')}
            </NavLink>
            <NavLink to="/hakkimizda">{t('nav.about')}</NavLink>
            <NavLink to="/destek">{t('nav.support')}</NavLink>
            {user ? (
              <>
                <NavLink to="/feed">{t('nav.home')}</NavLink>
                <NavLink to="/arama">{t('nav.search')}</NavLink>
                <NavLink to="/mesajlar">{t('nav.messages')}</NavLink>
                <NavLink to="/profil">{t('nav.profile')}</NavLink>
              </>
            ) : null}
          </nav>
          <div className="nav-cta">
            <select
              className="lang-select"
              value={language}
              onChange={(event) => setLanguage(event.target.value)}
              aria-label="language"
            >
              {availableLanguages.map((lng) => (
                <option key={lng} value={lng}>
                  {lng.toUpperCase()}
                </option>
              ))}
            </select>
            {loading ? null : user ? (
              <button
                type="button"
                className="btn btn-ghost"
                onClick={() => {
                  logout();
                  navigate('/');
                }}
              >
                {t('actions.logout')}
              </button>
            ) : (
              <>
                <Link className="btn btn-ghost" to="/giris">
                  {t('actions.login')}
                </Link>
                <Link className="btn btn-primary" to="/kayit">
                  {t('actions.register')}
                </Link>
              </>
            )}
          </div>
        </div>
      </header>
      <main className="container page">{children}</main>
      <footer className="footer">
        <div className="container list" style={{ gap: 18 }}>
          <StoreCta />
          <div>Aphel © 2025 — {t('footer.tagline')}</div>
        </div>
      </footer>
    </div>
  );
}
